import React from "react";

function traverse(root, path) {
  const count = path ? path.length : -1;
  let value = root;

  for (let index = 0; index < count; index += 1) {
    if (value !== null && value !== undefined) {
      value = value[path[index]];
    }
  }

  return count < 0 ? undefined : value;
}

function makeEnrichment(spec) {
  const paths = {};
  const keys = Object.keys(spec);

  for (let index = 0; index < keys.length; index += 1) {
    let value = spec[keys[index]];

    if (Array.isArray(value)) {
      value = value.slice();
    } else if (typeof value === "string") {
      value = value.split(".");
    } else {
      value = undefined;
    }

    paths[keys[index]] = value;
  }

  return (props) => {
    const extraProps = {};

    for (let index = 0; index < keys.length; index += 1) {
      extraProps[keys[index]] = traverse(props, paths[keys[index]]);
    }

    return extraProps;
  };
}

export default function connectExtraProps(enrich) {
  const getExtraProps =
    typeof enrich === "function" ? enrich : makeEnrichment(enrich);

  return function withExtraProps(Component) {
    return (props) => {
      const extraProps = getExtraProps(props);

      return <Component {...props} {...extraProps} />;
    };
  };
}
